import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';

// ============================================
// Routing simple basado en window.location.pathname
// ============================================
// - "/"            → landing pública
// - "/admin"       → login (o dashboard si hay sesión)
// - "/admin/..."   → idem (catch-all bajo /admin)
// Cualquier otra ruta cae a la landing.
//
// No usamos react-router para no inflar el bundle; basta con leer pathname
// al iniciar y usar history.pushState al navegar.
// ============================================
const ADMIN_PATH = '/admin';

function isAdminPath(pathname) {
  return pathname === ADMIN_PATH || pathname.startsWith(ADMIN_PATH + '/');
}

function pageFromUrl() {
  const usuario = localStorage.getItem('sg_usuario');
  const token = localStorage.getItem('sg_token');
  const isAdmin = isAdminPath(window.location.pathname);

  if (isAdmin) {
    return usuario && token ? 'dashboard' : 'login';
  }
  return 'landing';
}

function App() {
  const [currentPage, setCurrentPage] = useState(pageFromUrl);

  const [usuario, setUsuario] = useState(() => {
    const saved = localStorage.getItem('sg_usuario');
    return saved ? JSON.parse(saved) : null;
  });

  const [token, setToken] = useState(() => {
    return localStorage.getItem('sg_token') || null;
  });

  // Soportar back/forward del navegador
  useEffect(() => {
    const onPopState = () => setCurrentPage(pageFromUrl());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const pushUrl = (path) => {
    if (window.location.pathname !== path) {
      window.history.pushState({}, '', path);
    }
  };

  const handleLogin = (userData, jwt) => {
    localStorage.setItem('sg_usuario', JSON.stringify(userData));
    localStorage.setItem('sg_token', jwt);
    setUsuario(userData);
    setToken(jwt);
    pushUrl(ADMIN_PATH);
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    localStorage.removeItem('sg_usuario');
    localStorage.removeItem('sg_token');
    setUsuario(null);
    setToken(null);
    pushUrl('/');
    setCurrentPage('landing');
  };

  const navigateTo = (page) => {
    if (page === 'landing') pushUrl('/');
    else if (page === 'login' || page === 'dashboard') pushUrl(ADMIN_PATH);
    setCurrentPage(page);
  };

  return (
    <div>
      {currentPage === 'landing' && <LandingPage onNavigate={navigateTo} />}
      {currentPage === 'login' && <Login onLoginSuccess={handleLogin} onBack={() => navigateTo('landing')} />}
      {currentPage === 'dashboard' && usuario && <Dashboard usuario={usuario} token={token} onLogout={handleLogout} />}
    </div>
  );
}

export default App;
